import { Query } from '../Model/Query';
import { RegisterUnidentifiedPerson } from '../Model/RegisterUnidentifiedPerson';
export class RecordsUnidentifiedPerson {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findRegisters(opts) {
        var _a;
        if (((opts === null || opts === void 0 ? void 0 : opts.offset) || opts.offset >= 0) && (opts === null || opts === void 0 ? void 0 : opts.limit)) {
            const query = new Query(opts.offset, opts.limit);
            if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.search) {
                query.addFilter('search', [opts.filters.search]);
            }
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`register_unidentified_person?${params}`);
            if (!response.ok) {
                throw new Error(`Error al obtener los registros de antecedentes externos.`);
            }
            const content = await response.json();
            return content.map(diligence => new RegisterUnidentifiedPerson(diligence).getState());
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async lastIdentification(year) {
        if (year) {
            const response = await this.apiService.get('register_unidentified_person_identification/' + year);
            if (!response.ok) {
                throw new Error(`Error al obtener el numero de identificación.`);
            }
            const content = await response.text();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener el año.`);
        }
    }
    async saveRegisters(register) {
        const response = await this.apiService.post('register_unidentified_person', register);
        if (!response.ok) {
            throw new Error(`Error al obtener los registros de no identificados.`);
        }
        return true;
    }
    async findOne(id) {
        if (id) {
            const response = await this.apiService.get('register_unidentified_person/' + id);
            if (!response.ok) {
                throw new Error(`Error al obtener la persona.`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener el id.`);
        }
    }
    async getRecordsQuantity(opts) {
        var _a;
        const query = new Query();
        if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.search) {
            query.addFilter('search', [opts.filters.search]);
        }
        const params = this.queryParamsFactory.createQueryParams(query);
        const response = await this.apiService.get(`register_unidentified_person_quantity?${params}`);
        if (!response.ok) {
            throw new Error(`Error al obtener los registros de personas sin identificar.`);
        }
        const content = await response.json();
        return parseInt(content);
    }
}
